export enum ReportGroupByOption {
    none = 'none',
    status = 'status',
    responsible = 'responsible'
}
